import { useDictionary /*, useOrder*/ } from '@adamlip/okeoke.client';
import { PayAPI } from 'apis/PayApi';
import useStorage from 'hooks/useStorage';
import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import GridLoader from 'react-spinners/GridLoader';

function RafiPay() {
  const { id } = useParams();
  const { getValue } = useDictionary();
  const { getSV } = useStorage();
  const [orderUUID, setOrderUUID] = useState(null);
  const [paymentAgentID, setPaymentAgentID] = useState(null);
  const [countDown, setCountDown] = useState(null);
  const [tryAgain, setTryAgain] = useState(false);
  const timer = useRef(null);

  useEffect(() => {
    return () => {
      clearTimeout(timer.current);
    };
  }, []);

  useEffect(() => {
    if (id != null) {
      let params = id.split('-');
      setOrderUUID(params[0]);
      setPaymentAgentID(params[1]);
    }
  }, [id]);

  useEffect(() => {
    if (countDown != null) {
      timer.current = setTimeout(() => {
        setTryAgain(true);
        setCountDown(null);
      }, 10000);
    }
  }, [countDown]);

  useEffect(() => {
    if (orderUUID != null && paymentAgentID != null) start();
    // eslint-disable-next-line
  }, [orderUUID, paymentAgentID]);

  const start = () => {
    let identifier = getSV('rafiPayIdentifier');

    let data = {
      orderUUID: orderUUID,
      iban: identifier === 'rafiPayAccountNumber' && getSV('rafiPayAccountNumber') != null ? getSV('rafiPayAccountNumber') : null,
      email: identifier === 'rafiPayEmail' && getSV('rafiPayEmail') != null ? getSV('rafiPayEmail') : null,
      telNumber: identifier === 'rafiPayPhoneNumber' && getSV('rafiPayPhoneNumber') != null ? getSV('rafiPayPhoneNumber') : null,
      paymentAgentID: paymentAgentID,
    };

    PayAPI.startRafiPay(data)
      .then((response) => {
        if (response.data.success) {
          console.log(response);
        } else {
          console.log('Error!', response);
          setCountDown(true);
        }
      })
      .catch((e) => {
        console.error(e);
        setCountDown(true);
      });
  };

  const handleTryAgain = () => {
    setTryAgain(false);
    start();
  };

  return (
    <div className='rafi-pay-root'>
      {!tryAgain && (
        <div className='hidden-content appear loader'>
          <GridLoader color={'#000'} />
        </div>
      )}
      {tryAgain && (
        <>
          Gratulálok, sikeresen kivártad a 10 másodpercet a semmiért. Megpróbálod újra?
          <br />
          <br />
          <div className='btn primary hidden-content appear' onClick={handleTryAgain}>
            {getValue('app_v2_rafi_tryAgain')}
          </div>
        </>
      )}
    </div>
  );
}

export default RafiPay;
